/**
 * Date utilities shared by inspirations UI.
 *
 * Month labels are taken from i18n at the keys `dates.months.0` .. `dates.months.11`.
 */
export const MONTH_KEYS = [
  "dates.months.0",
  "dates.months.1",
  "dates.months.2",
  "dates.months.3",
  "dates.months.4",
  "dates.months.5",
  "dates.months.6",
  "dates.months.7",
  "dates.months.8",
  "dates.months.9",
  "dates.months.10",
  "dates.months.11",
];

export const monthLabel = (month, t) => t(MONTH_KEYS[month - 1]);

export const now = () => {
  const d = new Date();
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
};
